import { t as _objectSpread2 } from "./objectSpread2-CtW7yo8J.js";
import { t as SearchIcon } from "./SearchIcon-DbxRKLtx.js";
import { t as _objectWithoutProperties } from "./objectWithoutProperties-mN58NJZT.js";
import { d as _objectDestructuringEmpty, l as CloseIcon, n as createStoredConversations, o as SUGGESTED_QUETIONS_INDEX_NAME, p as LoadingIcon, s as ContentIcon, u as _extends } from "./useSearchClient-DUbFU6oe.js";
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Popover } from "@base-ui/react/popover";
import { DefaultChatTransport, generateId, isDataUIPart, isToolUIPart, lastAssistantMessageIsCompleteWithToolCalls } from "ai";
import { marked } from "marked";
import { Chat, useChat } from "@ai-sdk/react";

//#region src/icons/AlertIcon.tsx
function AlertIcon(props) {
	return /* @__PURE__ */ React.createElement("svg", _objectSpread2({
		width: "16",
		height: "16",
		viewBox: "0 0 24 24",
		fill: "none",
		fillRule: "evenodd",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	}, props), /* @__PURE__ */ React.createElement("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" }), /* @__PURE__ */ React.createElement("path", { d: "M12 9v4" }), /* @__PURE__ */ React.createElement("path", { d: "M12 17h.01" }));
}

//#endregion
//#region src/icons/StopIcon.tsx
function StopIcon() {
	return /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 18,
		height: 18,
		viewBox: "0 0 18 18",
		fill: "none"
	}, /* @__PURE__ */ React.createElement("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.99984 1.29102C4.74264 1.29102 1.2915 4.74215 1.2915 8.99935C1.2915 13.2565 4.74264 16.7077 8.99984 16.7077C13.257 16.7077 16.7082 13.2565 16.7082 8.99935C16.7082 4.74215 13.257 1.29102 8.99984 1.29102ZM0.0415039 8.99935C0.0415039 4.0518 4.05229 0.0410156 8.99984 0.0410156C13.9474 0.0410156 17.9582 4.0518 17.9582 8.99935C17.9582 13.9469 13.9474 17.9577 8.99984 17.9577C4.05229 17.9577 0.0415039 13.9469 0.0415039 8.99935ZM5.87484 6.49935C5.87484 6.15417 6.15466 5.87435 6.49984 5.87435H11.4998C11.845 5.87435 12.1248 6.15417 12.1248 6.49935V11.4993C12.1248 11.8445 11.845 12.1243 11.4998 12.1243H6.49984C6.15466 12.1243 5.87484 11.8445 5.87484 11.4993V6.49935ZM7.12484 7.12435V10.8743H10.8748V7.12435H7.12484Z",
		fill: "currentcolor"
	}));
}

//#endregion
//#region src/icons/MoreVerticalIcon.tsx
function MoreVerticalIcon() {
	return /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 4,
		height: 16,
		viewBox: "0 0 4 16",
		fill: "none"
	}, /* @__PURE__ */ React.createElement("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.99984 1.95898C1.88478 1.95898 1.7915 2.05226 1.7915 2.16732C1.7915 2.28238 1.88478 2.37565 1.99984 2.37565C2.1149 2.37565 2.20817 2.28238 2.20817 2.16732C2.20817 2.05226 2.1149 1.95898 1.99984 1.95898ZM0.541504 2.16732C0.541504 1.3619 1.19442 0.708984 1.99984 0.708984C2.80525 0.708984 3.45817 1.3619 3.45817 2.16732C3.45817 2.97273 2.80525 3.62565 1.99984 3.62565C1.19442 3.62565 0.541504 2.97273 0.541504 2.16732ZM1.99984 7.79232C1.88478 7.79232 1.7915 7.88559 1.7915 8.00065C1.7915 8.11571 1.88478 8.20898 1.99984 8.20898C2.1149 8.20898 2.20817 8.11571 2.20817 8.00065C2.20817 7.88559 2.1149 7.79232 1.99984 7.79232ZM0.541504 8.00065C0.541504 7.19524 1.19442 6.54232 1.99984 6.54232C2.80525 6.54232 3.45817 7.19524 3.45817 8.00065C3.45817 8.80607 2.80525 9.45898 1.99984 9.45898C1.19442 9.45898 0.541504 8.80607 0.541504 8.00065ZM1.99984 13.6257C1.88478 13.6257 1.7915 13.7189 1.7915 13.834C1.7915 13.949 1.88478 14.0423 1.99984 14.0423C2.1149 14.0423 2.20817 13.949 2.20817 13.834C2.20817 13.7189 2.1149 13.6257 1.99984 13.6257ZM0.541504 13.834C0.541504 13.0286 1.19442 12.3757 1.99984 12.3757C2.80525 12.3757 3.45817 13.0286 3.45817 13.834C3.45817 14.6394 2.80525 15.2923 1.99984 15.2923C1.19442 15.2923 0.541504 14.6394 0.541504 13.834Z",
		fill: "currentcolor"
	}));
}

//#endregion
//#region src/icons/ConversationHistoryIcon.tsx
function ConversationHistoryIcon() {
	return /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "18",
		height: "18",
		viewBox: "0 0 18 18",
		fill: "none"
	}, /* @__PURE__ */ React.createElement("path", {
		d: "M9 0.875C10.6068 0.875 12.1776 1.35149 13.5137 2.24414C14.8498 3.13693 15.8919 4.40598 16.5068 5.89062C17.1218 7.37522 17.2822 9.00892 16.9688 10.585C16.6552 12.1611 15.8814 13.6088 14.7451 14.7451C13.6088 15.8814 12.1611 16.6552 10.585 16.9688C9.00892 17.2822 7.37523 17.1218 5.89062 16.5068C4.40598 15.8919 3.13693 14.8498 2.24414 13.5137C1.35149 12.1776 0.875 10.6068 0.875 9C0.875 8.65482 1.15482 8.375 1.5 8.375C1.84518 8.375 2.125 8.65482 2.125 9C2.125 10.3596 2.52792 11.6888 3.2832 12.8193C4.03864 13.9499 5.1129 14.8312 6.36914 15.3516C7.62523 15.8718 9.00736 16.0083 10.3408 15.7432C11.6744 15.4779 12.8998 14.8228 13.8613 13.8613C14.8228 12.8998 15.4779 11.6744 15.7432 10.3408C16.0083 9.00736 15.8718 7.62523 15.3516 6.36914C14.8312 5.1129 13.9499 4.03864 12.8193 3.2832C11.6888 2.52792 10.3596 2.125 9 2.125C7.06829 2.125 5.21604 2.89096 3.82129 4.22949L3.00879 5.04199H5.66699C6.01202 5.04217 6.29199 5.32192 6.29199 5.66699C6.29182 6.01191 6.01191 6.29182 5.66699 6.29199H1.5C1.45939 6.29199 1.41889 6.28716 1.37891 6.2793C1.36148 6.27587 1.345 6.26949 1.32812 6.26465C1.267 6.24714 1.20782 6.22205 1.15332 6.18555C1.08536 6.14005 1.02604 6.08256 0.980469 6.01465C0.970244 5.99942 0.962841 5.98268 0.954102 5.9668C0.904937 5.87756 0.875056 5.77606 0.875 5.66699V1.5C0.875 1.15482 1.15482 0.875002 1.5 0.875C1.84518 0.875 2.125 1.15482 2.125 1.5V4.15723L2.94141 3.3418L2.9502 3.33301C4.57158 1.77433 6.73388 0.875 9 0.875ZM9.33301 4.20801C9.67808 4.20801 9.95783 4.48798 9.95801 4.83301V9.44727L12.9463 10.9414C13.2548 11.0958 13.3798 11.4707 13.2256 11.7793C13.0712 12.088 12.6955 12.213 12.3867 12.0586L9.05371 10.3926C8.84198 10.2867 8.70801 10.0697 8.70801 9.83301V4.83301C8.70818 4.48809 8.98809 4.20819 9.33301 4.20801Z",
		fill: "currentcolor"
	}));
}

//#endregion
//#region src/icons/NewConversationIcon.tsx
function NewConversationIcon() {
	return /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "19",
		height: "19",
		viewBox: "0 0 19 19",
		fill: "none"
	}, /* @__PURE__ */ React.createElement("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.712717 3.38039C1.14249 2.95062 1.72538 2.70917 2.33317 2.70917H8.1665C8.51168 2.70917 8.7915 2.989 8.7915 3.33417C8.7915 3.67935 8.51168 3.95917 8.1665 3.95917H2.33317C2.0569 3.95917 1.79195 4.06892 1.5966 4.26427C1.40125 4.45962 1.2915 4.72457 1.2915 5.00084V16.6675C1.2915 16.9438 1.40125 17.2087 1.5966 17.4041C1.79195 17.5994 2.0569 17.7092 2.33317 17.7092H13.9998C14.2761 17.7092 14.5411 17.5994 14.7364 17.4041C14.9318 17.2087 15.0415 16.9438 15.0415 16.6675V10.8342C15.0415 10.489 15.3213 10.2092 15.6665 10.2092C16.0117 10.2092 16.2915 10.489 16.2915 10.8342V16.6675C16.2915 17.2753 16.0501 17.8582 15.6203 18.288C15.1905 18.7177 14.6076 18.9592 13.9998 18.9592H2.33317C1.72538 18.9592 1.14249 18.7177 0.712717 18.288C0.282947 17.8582 0.0415039 17.2753 0.0415039 16.6675V5.00084C0.0415039 4.39305 0.282947 3.81016 0.712717 3.38039Z",
		fill: "currentcolor"
	}), /* @__PURE__ */ React.createElement("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.6665 2.19141C15.3634 2.19141 15.0728 2.3118 14.8584 2.52611L7.06419 10.3204L6.52548 12.4752L8.68031 11.9365L16.4746 4.14223C16.6889 3.92792 16.8093 3.63725 16.8093 3.33417C16.8093 3.03109 16.6889 2.74043 16.4746 2.52611C16.2603 2.3118 15.9696 2.19141 15.6665 2.19141ZM13.9746 1.64223C14.4233 1.1935 15.0319 0.941406 15.6665 0.941406C16.3011 0.941406 16.9097 1.1935 17.3584 1.64223C17.8072 2.09096 18.0593 2.69957 18.0593 3.33417C18.0593 3.96877 17.8072 4.57738 17.3584 5.02611L9.44178 12.9428C9.36168 13.0229 9.26132 13.0797 9.15142 13.1072L5.81809 13.9405C5.6051 13.9938 5.3798 13.9314 5.22456 13.7761C5.06932 13.6209 5.00692 13.3956 5.06016 13.1826L5.8935 9.84925C5.92097 9.73936 5.9778 9.639 6.0579 9.5589L13.9746 1.64223Z",
		fill: "currentcolor"
	}));
}

//#endregion
//#region src/icons/ToolIcon.tsx
function ToolIcon({ size = 20 }) {
	return /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: size,
		height: size,
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		className: "DocSearch-Search-Icon"
	}, /* @__PURE__ */ React.createElement("path", { d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" }));
}

//#endregion
//#region src/icons/MemoryIcon.tsx
function MemoryIcon() {
	return /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "2",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}, /* @__PURE__ */ React.createElement("path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" }), /* @__PURE__ */ React.createElement("path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" }));
}

//#endregion
//#region src/icons/BackIcon.tsx
function BackIcon({ size = 20, color = "currentColor" }) {
	return /* @__PURE__ */ React.createElement("svg", {
		width: size,
		height: size,
		className: "DocSearch-Back-Icon",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: color,
		strokeWidth: "1.6",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		"aria-hidden": "true"
	}, /* @__PURE__ */ React.createElement("path", { d: "m12 19-7-7 7-7" }), /* @__PURE__ */ React.createElement("path", { d: "M19 12H5" }));
}

//#endregion
//#region src/components/ConversationPromptSuggestions.tsx
const ConversationPromptSuggestions = React.memo(function ConversationPromptSuggestions({ title, suggestions, onSelectPromptSuggestion }) {
	const titleId = React.useId();
	const handleSelectPromptSuggestion = React.useCallback((e) => {
		onSelectPromptSuggestion(e.currentTarget.value);
	}, [onSelectPromptSuggestion]);
	return /* @__PURE__ */ React.createElement("section", {
		className: "DocSearch-PromptSuggestions",
		"aria-labelledby": titleId
	}, /* @__PURE__ */ React.createElement("h3", {
		className: "DocSearch-PromptSuggestions-Title",
		id: titleId
	}, title), /* @__PURE__ */ React.createElement("div", { className: "DocSearch-PromptSuggestions-Content" }, suggestions.map((suggestion) => /* @__PURE__ */ React.createElement("button", {
		key: suggestion,
		type: "button",
		className: "DocSearch-PromptSuggestions-Action",
		value: suggestion,
		onClick: handleSelectPromptSuggestion
	}, suggestion))));
});

//#endregion
//#region src/components/FeedbackActions.tsx
const FEEDBACK_REASONS = [
	{
		value: "incorrect",
		translationKey: "feedbackTagIncorrect",
		defaultLabel: "Incorrect or incomplete"
	},
	{
		value: "not_what_i_asked",
		translationKey: "feedbackTagNotWhatIAsked",
		defaultLabel: "Not what I asked for"
	},
	{
		value: "slow_or_buggy",
		translationKey: "feedbackTagSlowOrBuggy",
		defaultLabel: "Slow or buggy"
	},
	{
		value: "style_or_tone",
		translationKey: "feedbackTagStyleOrTone",
		defaultLabel: "Style or tone"
	},
	{
		value: "safety_or_legal",
		translationKey: "feedbackTagSafetyOrLegal",
		defaultLabel: "Safety or legal concern"
	},
	{
		value: "other",
		translationKey: "feedbackTagOther",
		defaultLabel: "Other"
	}
];
const MAX_NOTES_LENGTH = 1e3;
function FeedbackActions({ id, showActions, latestAssistantMessageContent, translations, conversations, onFeedback, isSidepanel = false }) {
	const [view, setView] = useState(() => {
		var _conversations$getOne;
		const message = (_conversations$getOne = conversations.getOne) === null || _conversations$getOne === void 0 ? void 0 : _conversations$getOne.call(conversations, id);
		return (message === null || message === void 0 ? void 0 : message.feedback) ? "thanks" : "actions";
	});
	const [tags, setTags] = useState([]);
	const [notes, setNotes] = useState("");
	const [saving, setSaving] = useState(false);
	const [savingError, setSavingError] = useState(null);
	const { likeButtonTitle = "Like", dislikeButtonTitle = "Dislike", thanksForFeedbackText = "Thanks for your feedback!" } = translations;
	const handleLike = async () => {
		if (saving) return;
		setSavingError(null);
		setSaving(true);
		try {
			await (onFeedback === null || onFeedback === void 0 ? void 0 : onFeedback(id, { thumbs: 1 }));
			setView("thanks");
		} catch (error) {
			setSavingError(error);
		} finally {
			setSaving(false);
		}
	};
	const handleDislike = () => {
		setSavingError(null);
		setView("note");
	};
	const handleToggleTag = (value) => {
		setTags((prev) => prev.includes(value) ? prev.filter((tag) => tag !== value) : [...prev, value]);
	};
	const handleSubmitNote = async () => {
		if (saving) return;
		setSavingError(null);
		setSaving(true);
		try {
			await (onFeedback === null || onFeedback === void 0 ? void 0 : onFeedback(id, {
				thumbs: 0,
				tags: tags.length > 0 ? tags : void 0,
				notes: notes.trim() || void 0
			}));
			setView("thanks");
		} catch (error) {
			setSavingError(error);
		} finally {
			setSaving(false);
		}
	};
	const handleCloseNote = () => {
		setTags([]);
		setNotes("");
		setSavingError(null);
		setView("actions");
	};
	if (!showActions || !latestAssistantMessageContent) return null;
	const copyButton = /* @__PURE__ */ React.createElement(CopyButton, {
		translations,
		onClick: () => navigator.clipboard.writeText(latestAssistantMessageContent)
	});
	return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "DocSearch-AskAiScreen-Actions-Controls" }, isSidepanel ? copyButton : null, view === "thanks" ? /* @__PURE__ */ React.createElement("p", { className: "DocSearch-AskAiScreen-FeedbackText DocSearch-AskAiScreen-FeedbackText--visible" }, thanksForFeedbackText) : /* @__PURE__ */ React.createElement(React.Fragment, null, saving && view === "actions" ? /* @__PURE__ */ React.createElement(LoadingIcon, { className: "DocSearch-AskAiScreen-SmallerLoadingIcon" }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(LikeButton, {
		title: likeButtonTitle,
		onClick: handleLike
	}), /* @__PURE__ */ React.createElement(DislikeButton, {
		title: dislikeButtonTitle,
		onClick: handleDislike
	})), savingError && view === "actions" ? /* @__PURE__ */ React.createElement("p", { className: "DocSearch-AskAiScreen-FeedbackText" }, savingError.message || "An error occured") : null), isSidepanel ? null : copyButton), view === "note" ? /* @__PURE__ */ React.createElement(NegativeFeedbackPanel, {
		translations,
		tags,
		notes,
		saving,
		savingError,
		onToggleTag: handleToggleTag,
		onNotesChange: setNotes,
		onSubmit: handleSubmitNote,
		onClose: handleCloseNote
	}) : null);
}
function NegativeFeedbackPanel({ translations, tags, notes, saving, savingError, onToggleTag, onNotesChange, onSubmit, onClose }) {
	const feedbackTitleId = React.useId();
	const { feedbackPanelTitle = "What went wrong? (optional)", feedbackDetailsPlaceholder = "Share some details...", feedbackSubmitButtonText = "Submit", feedbackCancelButtonText = "Cancel" } = translations;
	return /* @__PURE__ */ React.createElement("div", {
		className: "DocSearch-Feedback-Panel",
		role: "group",
		"aria-labelledby": feedbackTitleId
	}, /* @__PURE__ */ React.createElement("div", { className: "DocSearch-Feedback-Panel-Header" }, /* @__PURE__ */ React.createElement("p", {
		className: "DocSearch-Feedback-Panel-Title",
		id: feedbackTitleId
	}, feedbackPanelTitle)), /* @__PURE__ */ React.createElement("div", { className: "DocSearch-Feedback-Panel-Reasons" }, FEEDBACK_REASONS.map((reason) => {
		var _translations$reason$;
		const isSelected = tags.includes(reason.value);
		return /* @__PURE__ */ React.createElement("button", {
			key: reason.value,
			type: "button",
			className: "DocSearch-Feedback-Panel-Reason",
			"aria-pressed": isSelected,
			onClick: () => onToggleTag(reason.value)
		}, /* @__PURE__ */ React.createElement("span", null, (_translations$reason$ = translations[reason.translationKey]) !== null && _translations$reason$ !== void 0 ? _translations$reason$ : reason.defaultLabel));
	})), /* @__PURE__ */ React.createElement("textarea", {
		className: "DocSearch-Feedback-Panel-Textarea",
		placeholder: feedbackDetailsPlaceholder,
		value: notes,
		rows: 3,
		maxLength: MAX_NOTES_LENGTH,
		onChange: (event) => onNotesChange(event.target.value.slice(0, MAX_NOTES_LENGTH))
	}), /* @__PURE__ */ React.createElement("p", {
		className: "DocSearch-Feedback-Panel-CharCount",
		"aria-live": "polite"
	}, notes.length, "/", MAX_NOTES_LENGTH), savingError ? /* @__PURE__ */ React.createElement("p", { className: "DocSearch-Feedback-Panel-Error" }, savingError.message || "An error occured") : null, /* @__PURE__ */ React.createElement("div", { className: "DocSearch-Feedback-Panel-Actions" }, /* @__PURE__ */ React.createElement("button", {
		type: "button",
		className: "DocSearch-Feedback-Panel-Cancel",
		onClick: onClose
	}, feedbackCancelButtonText), /* @__PURE__ */ React.createElement("button", {
		type: "button",
		className: "DocSearch-Feedback-Panel-Submit",
		disabled: saving,
		onClick: onSubmit
	}, saving ? /* @__PURE__ */ React.createElement(LoadingIcon, { className: "DocSearch-AskAiScreen-SmallerLoadingIcon" }) : feedbackSubmitButtonText)));
}
function CopyButton({ onClick, translations }) {
	const { copyButtonTitle = "Copy", copyButtonCopiedText = "Copied!" } = translations;
	const [isCopied, setIsCopied] = useState(false);
	useEffect(() => {
		if (isCopied) {
			const timer = setTimeout(() => {
				setIsCopied(false);
			}, 1500);
			return () => clearTimeout(timer);
		}
	}, [isCopied]);
	const handleClick = () => {
		onClick();
		setIsCopied(true);
	};
	return /* @__PURE__ */ React.createElement("button", {
		type: "button",
		className: `DocSearch-AskAiScreen-ActionButton DocSearch-AskAiScreen-CopyButton ${isCopied ? "DocSearch-AskAiScreen-CopyButton--copied" : ""}`,
		disabled: isCopied,
		title: isCopied ? copyButtonCopiedText : copyButtonTitle,
		onClick: handleClick
	}, isCopied ? /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}, /* @__PURE__ */ React.createElement("path", { d: "M20 6 9 17l-5-5" })) : /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}, /* @__PURE__ */ React.createElement("rect", {
		width: "14",
		height: "14",
		x: "8",
		y: "8",
		rx: "2",
		ry: "2"
	}), /* @__PURE__ */ React.createElement("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })));
}
function LikeButton({ title, onClick }) {
	return /* @__PURE__ */ React.createElement("button", {
		type: "button",
		className: "DocSearch-AskAiScreen-ActionButton DocSearch-AskAiScreen-LikeButton",
		title,
		onClick
	}, /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}, /* @__PURE__ */ React.createElement("path", { d: "M7 10v12" }), /* @__PURE__ */ React.createElement("path", { d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" })));
}
function DislikeButton({ title, onClick }) {
	return /* @__PURE__ */ React.createElement("button", {
		type: "button",
		className: "DocSearch-AskAiScreen-ActionButton DocSearch-AskAiScreen-DislikeButton",
		title,
		onClick
	}, /* @__PURE__ */ React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}, /* @__PURE__ */ React.createElement("path", { d: "M17 14V2" }), /* @__PURE__ */ React.createElement("path", { d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" })));
}

//#endregion
//#region src/components/ui/Popover.tsx
const _excluded$2 = ["className"];
const _excluded2 = [
	"align",
	"alignOffset",
	"side",
	"sideOffset",
	"collisionBoundary",
	"container",
	"children"
];
function Popover$1(_ref) {
	let props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
	return /* @__PURE__ */ React.createElement(Popover.Root, props);
}
Popover$1.Trigger = React.forwardRef((_ref2, ref) => {
	let { className } = _ref2, props = _objectWithoutProperties(_ref2, _excluded$2);
	const cn = `DocSearch-Popover-Trigger${className ? ` ${className}` : ""}`;
	return /* @__PURE__ */ React.createElement(Popover.Trigger, _objectSpread2({
		className: cn,
		ref
	}, props));
});
function PopoverPopup(_ref3) {
	let { align = "center", alignOffset = 0, side = "bottom", sideOffset = 4, collisionBoundary = "clipping-ancestors", container, children } = _ref3, props = _objectWithoutProperties(_ref3, _excluded2);
	return /* @__PURE__ */ React.createElement(Popover.Portal, { container }, /* @__PURE__ */ React.createElement(Popover.Positioner, {
		className: "DocSearch-Popover-Positioner",
		align,
		alignOffset,
		side,
		sideOffset,
		collisionBoundary
	}, /* @__PURE__ */ React.createElement(Popover.Popup, _objectSpread2({ className: "DocSearch-Popover-Popup" }, props), /* @__PURE__ */ React.createElement(Popover.Arrow, { className: "DocSearch-Popover-Arrow" }), /* @__PURE__ */ React.createElement(Popover.Close, { className: "DocSearch-Popover-Close" }, /* @__PURE__ */ React.createElement(CloseIcon, null)), children)));
}
Popover$1.Popup = PopoverPopup;
function PopoverTitle(_ref4) {
	let props = _extends({}, (_objectDestructuringEmpty(_ref4), _ref4));
	return /* @__PURE__ */ React.createElement(Popover.Title, _objectSpread2({ className: "DocSearch-Popover-Title" }, props));
}
Popover$1.Title = PopoverTitle;

//#endregion
//#region src/components/SourcesPanel.tsx
function SourcesPanel({ links, titleText = "Source", pluralTitleText = "Sources" }) {
	const [open, setOpen] = React.useState(false);
	const triggerRef = React.useRef(null);
	const [boundary, setBoundary] = React.useState(null);
	const sourcesTitle = links.length > 1 ? pluralTitleText : titleText;
	useEffect(() => {
		var _ref, _trigger$closest;
		if (!open) return;
		const trigger = triggerRef.current;
		const scrollContainer = (_ref = (_trigger$closest = trigger === null || trigger === void 0 ? void 0 : trigger.closest(".DocSearch-Sidepanel-Content")) !== null && _trigger$closest !== void 0 ? _trigger$closest : trigger === null || trigger === void 0 ? void 0 : trigger.closest(".DocSearch-Dropdown")) !== null && _ref !== void 0 ? _ref : null;
		setBoundary(scrollContainer);
		if (!scrollContainer) return;
		const handleScroll = () => {
			if (!triggerRef.current) return;
			const triggerRect = triggerRef.current.getBoundingClientRect();
			const containerRect = scrollContainer.getBoundingClientRect();
			if (triggerRect.bottom <= containerRect.top || triggerRect.top >= containerRect.bottom) setOpen(false);
		};
		scrollContainer.addEventListener("scroll", handleScroll, { passive: true });
		return () => {
			scrollContainer.removeEventListener("scroll", handleScroll);
		};
	}, [open]);
	if (links.length === 0) return null;
	return /* @__PURE__ */ React.createElement(Popover$1, {
		open,
		modal: "trap-focus",
		onOpenChange: setOpen
	}, /* @__PURE__ */ React.createElement(Popover$1.Trigger, {
		ref: triggerRef,
		className: "DocSearch-AskAiScreen-Sources-Action"
	}, /* @__PURE__ */ React.createElement("span", { className: "DocSearch-AskAiScreen-Sources-Action-icon" }, /* @__PURE__ */ React.createElement(ContentIcon, null)), /* @__PURE__ */ React.createElement("span", { className: "DocSearch-AskAiScreen-Sources-Action-text" }, links.length, " ", sourcesTitle)), /* @__PURE__ */ React.createElement(Popover$1.Popup, {
		container: boundary,
		sideOffset: 10,
		align: "start",
		alignOffset: -16,
		collisionBoundary: boundary !== null && boundary !== void 0 ? boundary : "clipping-ancestors"
	}, /* @__PURE__ */ React.createElement(Popover$1.Title, null, sourcesTitle), /* @__PURE__ */ React.createElement("ul", { className: "DocSearch-AskAiScreen-Sources" }, links.map((l) => /* @__PURE__ */ React.createElement("li", {
		key: l.url,
		className: "DocSearch-AskAiScreen-Sources-source"
	}, /* @__PURE__ */ React.createElement("a", {
		href: l.url,
		target: "_blank",
		rel: "noopener noreferrer"
	}, /* @__PURE__ */ React.createElement(ContentIcon, null), /* @__PURE__ */ React.createElement("span", { className: "DocSearch-AskAiScreen-Sources-source-title" }, l.title || l.url)))))));
}

//#endregion
//#region src/utils/askAiBlockingMatchers.ts
const PROMPT_BLOCKING_CODES = /* @__PURE__ */ new Set([
	"AI-203",
	"AI-205",
	"AI-224",
	"AI-225"
]);
function readStringField(value, key) {
	for (const [field, fieldValue] of Object.entries(value)) if (field.toLowerCase() === key.toLowerCase() && typeof fieldValue === "string" && fieldValue.trim() !== "") return fieldValue.trim();
}
function extractErrorCode(message) {
	const directMatch = /\b(AI-\d{3})\b/i.exec(message);
	if (directMatch) return directMatch[1].toUpperCase();
}
function parseJson(message) {
	try {
		const parsed = JSON.parse(message);
		if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) return parsed;
	} catch (_unused) {}
	return null;
}
function matchesDomainBlock(message) {
	return /\brequest blocked for this domain\b/.test(message) || /\bblocked for this domain\b/.test(message);
}
function matchesRateLimit(message) {
	return /\b429\b/.test(message) || /\brate\s*limit/.test(message) || /\bretry\s+after\s+\d+/.test(message) || /\btoo\s+many\s+attempts\b/.test(message) || /\btoo_many_requests\b/.test(message);
}
function matchesTokenOutputLimit(message) {
	return /\btokenoutputlimiterror\b/.test(message) || /could not complete response due to token output limits/.test(message);
}
function matchesAccessOrLimit(message) {
	return /\bwhitelist(?:ed)?\b/.test(message) || /\bnot\s+allowed\s+for\s+this\s+domain\b/.test(message) || /\bcontext\s+length\b/.test(message) || /\b(?:max|maximum)\s+tokens?\b/.test(message) || /\btoken\s+limit\b/.test(message) || /\btoken\s+output\b/.test(message) || /\boutput\s+limits?\b/.test(message) || /\bstep\s+limit\b/.test(message) || /\b(?:max|maximum)(?:\s+agent)?\s+steps?\b/.test(message);
}
function jsonImpliesCostControl(value) {
	var _readStringField, _readStringField2, _readStringField3;
	const type = (_readStringField = readStringField(value, "type")) !== null && _readStringField !== void 0 ? _readStringField : "";
	const error = (_readStringField2 = readStringField(value, "error")) !== null && _readStringField2 !== void 0 ? _readStringField2 : "";
	const message = (_readStringField3 = readStringField(value, "message")) !== null && _readStringField3 !== void 0 ? _readStringField3 : "";
	return /tokenoutput|outputlimit|steplimit|maxstep|ratelimit|domainnotallowed/i.test(type) || error.toUpperCase() === "TOO_MANY_REQUESTS" || matchesRateLimit(`${error} ${message}`.toLowerCase()) || matchesAccessOrLimit(`${error} ${message}`.toLowerCase());
}
const BLOCKING_MATCHERS = [
	{ matches: ({ code }) => Boolean(code && PROMPT_BLOCKING_CODES.has(code)) },
	{
		matches: ({ parsedJson }) => {
			var _readStringField4;
			return Boolean(parsedJson && matchesDomainBlock(((_readStringField4 = readStringField(parsedJson, "message")) !== null && _readStringField4 !== void 0 ? _readStringField4 : "").toLowerCase()));
		},
		showNewConversationLink: false
	},
	{ matches: ({ parsedJson }) => Boolean(parsedJson && jsonImpliesCostControl(parsedJson)) },
	{
		matches: ({ messageLower }) => matchesTokenOutputLimit(messageLower),
		showNewConversationLink: false
	},
	{ matches: ({ messageLower }) => matchesRateLimit(messageLower) },
	{
		matches: ({ messageLower }) => matchesDomainBlock(messageLower),
		showNewConversationLink: false
	},
	{ matches: ({ messageLower }) => matchesAccessOrLimit(messageLower) }
];
function resolvePromptBlockingError(error) {
	var _error$message;
	const message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : "";
	const context = {
		message,
		messageLower: message.toLowerCase(),
		parsedJson: parseJson(message),
		code: extractErrorCode(message)
	};
	const matches = BLOCKING_MATCHERS.filter((matcher) => matcher.matches(context));
	return {
		blocking: matches.length > 0,
		showNewConversationLink: matches.every((matcher) => matcher.showNewConversationLink !== false)
	};
}
function isTokenOutputLimitError(error) {
	var _error$message2;
	return Boolean(error && matchesTokenOutputLimit(((_error$message2 = error.message) !== null && _error$message2 !== void 0 ? _error$message2 : "").toLowerCase()));
}

//#endregion
//#region src/utils/sanitize.ts
/** Escapes HTML special characters for safe interpolation into HTML strings. */
function escapeHtml(unsafe) {
	return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
/** Strips HTML tags and escapes the remainder for plain-text React children. */
function sanitizeUserInput(input) {
	return escapeHtml(input.replace(/<[^>]*>/g, ""));
}
function decodeUrlForSchemeCheck(value) {
	let current = value;
	for (let i = 0; i < 3; i += 1) try {
		const decoded = decodeURIComponent(current);
		if (decoded === current) break;
		current = decoded;
	} catch (_unused) {
		break;
	}
	return current;
}
function stripControlsAndWhitespace(value) {
	let result = "";
	for (let i = 0; i < value.length; i += 1) {
		const code = value.charCodeAt(i);
		if (code > 32 && code !== 127) result += value[i];
	}
	return result;
}
/**
* Returns a URL safe for href/src, or '' if unsafe. Does not HTML-escape —
* callers building HTML strings must escape separately.
*/
function sanitizeUrl(url) {
	if (!url) return "";
	const trimmed = url.trim();
	if (!trimmed) return "";
	const normalized = stripControlsAndWhitespace(decodeUrlForSchemeCheck(trimmed));
	if (!normalized) return "";
	if (normalized.startsWith("//")) return "";
	if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(normalized)) return trimmed;
	try {
		const parsed = new URL(normalized);
		if (parsed.protocol === "http:" || parsed.protocol === "https:" || parsed.protocol === "mailto:") return normalized;
	} catch (_unused2) {
		return "";
	}
	return "";
}

//#endregion
//#region src/utils/ai.ts
function extractLinksFromMessage(message) {
	const links = [];
	const seen = /* @__PURE__ */ new Set();
	if (!message) return [];
	message.parts.forEach((part) => {
		if (part.type !== "text") return;
		if (part.text.length === 0) return;
		const markdownLinkRegex = /\[([^\]]*)\]\(([^)]+)\)/g;
		const plainLinkRegex = /https?:\/\/[^\s<>"{}|\\^`[\]]+/g;
		const cleanText = part.text.replace(/```[\s\S]*?```/g, "").replace(/`[^`]*`/g, "");
		const markdownMatches = cleanText.matchAll(markdownLinkRegex);
		for (const match of markdownMatches) {
			const title = match[1].trim();
			const url = sanitizeUrl(match[2]);
			if (url && !seen.has(url)) {
				seen.add(url);
				links.push({
					url,
					title: title || void 0
				});
			}
		}
		const plainUrls = cleanText.replace(markdownLinkRegex, " ").matchAll(plainLinkRegex);
		for (const match of plainUrls) {
			const cleanUrl = sanitizeUrl(match[0].replace(/[.,;:!?]+$/, ""));
			if (cleanUrl && !seen.has(cleanUrl)) {
				seen.add(cleanUrl);
				links.push({ url: cleanUrl });
			}
		}
	});
	return links;
}
const buildDummyAskAiHit = (query, messages, chatId) => {
	const textPart = messages[0].parts.find((part) => part.type === "text");
	const sanitizedText = (textPart === null || textPart === void 0 ? void 0 : textPart.text) ? sanitizeUserInput(textPart.text) : "";
	return {
		query,
		objectID: sanitizedText,
		chatId,
		messages,
		type: "askAI",
		anchor: "stored",
		content: null,
		hierarchy: {
			lvl0: "askAI",
			lvl1: sanitizedText,
			lvl2: (/* @__PURE__ */ new Date()).toISOString(),
			lvl3: null,
			lvl4: null,
			lvl5: null,
			lvl6: null
		},
		url: "",
		url_without_anchor: ""
	};
};
const getMessageContent = (message) => {
	var _message$parts;
	return ((_message$parts = message === null || message === void 0 ? void 0 : message.parts) !== null && _message$parts !== void 0 ? _message$parts : []).filter((part) => part.type === "text").map((part) => part.text).join("\n\n");
};
/** Helper function to check if an error reports the conversation depth limit. */
function isThreadDepthError(error) {
	var _error$message;
	if (!error) return false;
	return /(?:ai-217|conversation\s+depth)/i.test((_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : "");
}
function isAskAiPromptBlockingError(error) {
	return Boolean(error && (isThreadDepthError(error) || resolvePromptBlockingError(error).blocking));
}
function isAgentStudioTokenOutputLimitError(error) {
	return isTokenOutputLimitError(error);
}
function showAskAiBlockingBannerNewConversationLink(error) {
	if (!error || isThreadDepthError(error)) return true;
	return resolvePromptBlockingError(error).showNewConversationLink;
}
function extractAgentStudioErrorFieldMessage(raw) {
	let value = raw.trim();
	for (let iteration = 0; iteration < 10 && value; iteration++) try {
		var _exec, _fieldMatch$;
		const parsed = JSON.parse(value);
		if (typeof parsed === "string") {
			value = parsed.trim();
			continue;
		}
		if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
			const record = parsed;
			const message = readStringField(record, "message");
			const error = readStringField(record, "error");
			if (message) return message;
			if (error) return error;
		}
		const fieldMatch = (_exec = /"message"\s*:\s*"((?:[^"\\]|\\.)*)"/.exec(value)) !== null && _exec !== void 0 ? _exec : /"error"\s*:\s*"((?:[^"\\]|\\.)*)"/.exec(value);
		return fieldMatch === null || fieldMatch === void 0 || (_fieldMatch$ = fieldMatch[1]) === null || _fieldMatch$ === void 0 ? void 0 : _fieldMatch$.replace(/\\"/g, "\"").replace(/\\\\/g, "\\").trim();
	} catch (_unused) {
		if (value.includes("\\\"")) {
			value = value.replace(/\\"/g, "\"").replace(/\\\\/g, "\\").trim();
			continue;
		}
		return;
	}
}
function getAskAiBlockingBannerMessage(error) {
	var _error$message2;
	if (!error) return;
	const extracted = extractAgentStudioErrorFieldMessage((_error$message2 = error.message) !== null && _error$message2 !== void 0 ? _error$message2 : "");
	if (isThreadDepthError(error) && (/^\s*AI-217\s*$/i.test(error.message) || /^\s*\{.*\}\s*$/.test(error.message) && !extracted)) return;
	const message = (extracted !== null && extracted !== void 0 ? extracted : error.message.replace(/\s*\(AI-\d{3}\)\s*$/i, "")).trim();
	if (message && !(message.startsWith("{") && message.endsWith("}"))) return message;
	if (isAgentStudioTokenOutputLimitError(error)) return "Could not complete response due to token output limits";
}
const EMPTY_TOOLS = Object.freeze({});
function isAIToolPart(part) {
	return part.type.startsWith("tool-");
}
function isSearchToolPart(part) {
	return part.type === "tool-searchIndex" || part.type === "tool-algolia_search_index" || part.type.startsWith("tool-algolia_search_index_");
}
function isSearchOutputPart(part) {
	return isAIToolPart(part) && isSearchToolPart(part) && part.state === "output-available";
}
function sanitizeMessagesForRequest(messages) {
	var _sanitizedMessages;
	let sanitizedMessages;
	messages.forEach((message, index) => {
		const parts = message.parts.filter((part) => {
			if (isDataUIPart(part)) return false;
			if (isToolUIPart(part) && part.state.startsWith("input-")) return false;
			return true;
		});
		if (parts.length === message.parts.length) {
			sanitizedMessages === null || sanitizedMessages === void 0 || sanitizedMessages.push(message);
			return;
		}
		if (!sanitizedMessages) sanitizedMessages = messages.slice(0, index);
		sanitizedMessages.push(_objectSpread2(_objectSpread2({}, message), {}, { parts }));
	});
	return (_sanitizedMessages = sanitizedMessages) !== null && _sanitizedMessages !== void 0 ? _sanitizedMessages : messages;
}
function getAgentPromptSuggestions(parts) {
	const suggestionsPart = parts.find((part) => part.type === "data-suggestions");
	if (!suggestionsPart) return [];
	return suggestionsPart.data.suggestions;
}
function getSearchToolQueries(part) {
	if (part.state !== "input-available" && part.state !== "output-available") return [];
	if (part.type === "tool-searchIndex") {
		var _ref, _part$output$query, _part$output, _part$input;
		const query = ((_ref = (_part$output$query = (_part$output = part.output) === null || _part$output === void 0 ? void 0 : _part$output.query) !== null && _part$output$query !== void 0 ? _part$output$query : (_part$input = part.input) === null || _part$input === void 0 ? void 0 : _part$input.query) !== null && _ref !== void 0 ? _ref : "").trim();
		return query ? [query] : [];
	}
	if ("queries" in part.input && Array.isArray(part.input.queries)) return part.input.queries.map(({ query }) => query.trim()).filter(Boolean);
	if ("query" in part.input && typeof part.input.query === "string") {
		const query = part.input.query.trim();
		return query ? [query] : [];
	}
	return [];
}

//#endregion
//#region src/components/ui/ToolState.tsx
function ToolState({ icon, shimmer = false, children, variant }) {
	const className = `DocSearch-AskAiScreen-MessageContent-Tool Tool--${variant}${shimmer ? " DocSearch-shimmer" : ""}`;
	return /* @__PURE__ */ React.createElement("div", { className }, icon, children);
}

//#endregion
//#region src/components/ToolCall.tsx
function SearchTool({ part, translations, onSearchQueryClick }) {
	const { searchingText, preToolCallText, toolCallResultText } = translations;
	switch (part.state) {
		case "input-streaming": return /* @__PURE__ */ React.createElement(ToolState, {
			shimmer: true,
			icon: /* @__PURE__ */ React.createElement(LoadingIcon, { className: "DocSearch-AskAiScreen-SmallerLoadingIcon" }),
			variant: "PartialCall"
		}, /* @__PURE__ */ React.createElement("span", null, searchingText));
		case "input-available": {
			const queries = getSearchToolQueries(part);
			return /* @__PURE__ */ React.createElement(React.Fragment, null, queries.map((q, index) => /* @__PURE__ */ React.createElement(ToolState, {
				key: `${part.toolCallId}-call-${index}`,
				shimmer: true,
				icon: /* @__PURE__ */ React.createElement(LoadingIcon, { className: "DocSearch-AskAiScreen-SmallerLoadingIcon" }),
				variant: "Call"
			}, /* @__PURE__ */ React.createElement("span", null, preToolCallText, " ", `"${q}" ...`))));
		}
		case "output-available": {
			const queries = getSearchToolQueries(part);
			return /* @__PURE__ */ React.createElement(React.Fragment, null, queries.map((q, index) => /* @__PURE__ */ React.createElement(ToolState, {
				key: `${part.toolCallId}-result-${index}`,
				icon: /* @__PURE__ */ React.createElement(SearchIcon, null),
				variant: "Result"
			}, /* @__PURE__ */ React.createElement("span", null, toolCallResultText, " ", onSearchQueryClick ? /* @__PURE__ */ React.createElement("span", {
				role: "button",
				tabIndex: 0,
				className: "DocSearch-AskAiScreen-MessageContent-Tool-Query",
				onKeyDown: (e) => {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();
						onSearchQueryClick(q);
					}
				},
				onClick: () => onSearchQueryClick(q)
			}, " ", "\"", q, "\"") : /* @__PURE__ */ React.createElement("span", { className: "DocSearch-AskAiScreen-MessageContent-Tool-Query" }, " ", "\"", q, "\"")))));
		}
		default: return null;
	}
}
function CustomTool({ tool, part }) {
	const toolOutput = useMemo(() => {
		if (part.state !== "output-available") return null;
		return tool.render({ message: {
			input: part.input,
			output: part.output
		} });
	}, [
		part.input,
		part.output,
		tool,
		part.state
	]);
	if (part.state === "output-error") return null;
	if (part.state !== "output-available") {
		const { callingToolText = "Loading tool" } = tool.translations || {};
		return /* @__PURE__ */ React.createElement(ToolState, {
			shimmer: true,
			variant: "PartialCall",
			icon: /* @__PURE__ */ React.createElement(ToolIcon, null)
		}, /* @__PURE__ */ React.createElement("span", null, callingToolText));
	}
	if (!toolOutput) return null;
	return /* @__PURE__ */ React.createElement(ToolState, {
		icon: /* @__PURE__ */ React.createElement(ToolIcon, null),
		variant: "Result"
	}, /* @__PURE__ */ React.createElement("span", null, toolOutput));
}
function MemoryTool({ part, translations }) {
	const { savedMemoryToolResultText, memoryToolResultText } = translations;
	if (part.state === "output-error") return null;
	if (part.type === "tool-algolia_memorize") return /* @__PURE__ */ React.createElement(ToolState, {
		variant: "Result",
		icon: /* @__PURE__ */ React.createElement(MemoryIcon, null)
	}, savedMemoryToolResultText);
	return /* @__PURE__ */ React.createElement(ToolState, {
		variant: "Result",
		icon: /* @__PURE__ */ React.createElement(MemoryIcon, null)
	}, memoryToolResultText);
}
function isMemoryToolPart(part) {
	return part.type === "tool-algolia_ponder" || part.type === "tool-algolia_memorize" || part.type === "tool-algolia_memory_search";
}
function ToolCall({ part, translations, tools, onSearchQueryClick, memoryEnabled = false }) {
	const customTool = tools[part.type.replace("tool-", "")];
	if (customTool) return /* @__PURE__ */ React.createElement(CustomTool, {
		tool: customTool,
		part
	});
	if (memoryEnabled && isMemoryToolPart(part)) return /* @__PURE__ */ React.createElement(MemoryTool, {
		part,
		translations
	});
	if (isSearchToolPart(part)) return /* @__PURE__ */ React.createElement(SearchTool, {
		part,
		translations,
		onSearchQueryClick
	});
	return null;
}

//#endregion
//#region src/utils/markdown.ts
const renderer = new marked.Renderer();
renderer.code = ({ text, lang = "", escaped }) => {
	const safeLang = /^[a-zA-Z0-9_-]+$/.test(lang) ? lang : "";
	const languageClass = safeLang ? `language-${safeLang}` : "";
	const safeCode = escaped ? text : escapeHtml(text);
	return `
    <div class="DocSearch-CodeSnippet">
      <button class="DocSearch-CodeSnippet-CopyButton" data-code="${encodeURIComponent(text)}" aria-label="copy code"><svg class="DocSearch-CodeSnippet-CopyIcon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="14" x="8" y="8" rx="2" ry="2" /><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" /></svg><svg class="DocSearch-CodeSnippet-CheckIcon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5" /></svg><span class="DocSearch-CodeSnippet-CopyButton-Label"></span></button>
      <pre><code class="${languageClass}">${safeCode}</code></pre>
    </div>
  `;
};
renderer.link = ({ href, title, text }) => {
	const safeHref = escapeHtml(sanitizeUrl(href));
	const textEscaped = escapeHtml(text);
	if (!safeHref) return textEscaped;
	return `<a href="${safeHref}"${title ? ` title="${escapeHtml(title)}"` : ""} target="_blank" rel="noopener noreferrer">${textEscaped}</a>`;
};
renderer.image = ({ href, title, text }) => {
	const safeHref = escapeHtml(sanitizeUrl(href));
	if (!safeHref) return escapeHtml(text);
	const titleAttr = title ? ` title="${escapeHtml(title)}"` : "";
	return `<img src="${safeHref}" alt="${escapeHtml(text)}"${titleAttr} />`;
};
renderer.html = ({ text }) => escapeHtml(text);
/** Parses markdown into HTML safe for `dangerouslySetInnerHTML`. */
function parseMarkdownToSafeHtml(content) {
	return marked.parse(content, {
		gfm: true,
		breaks: true,
		renderer
	});
}

//#endregion
//#region src/MemoizedMarkdown.tsx
const MemoizedMarkdown = memo(({ content, copyButtonText, copyButtonCopiedText, isStreaming }) => {
	const html = useMemo(() => parseMarkdownToSafeHtml(content), [content]);
	const containerRef = useRef(null);
	useEffect(() => {
		const container = containerRef.current;
		if (!container) return;
		Array.from(container.querySelectorAll(".DocSearch-CodeSnippet-CopyButton")).forEach((btn) => {
			const label = btn.querySelector(".DocSearch-CodeSnippet-CopyButton-Label");
			if (label) label.textContent = copyButtonText;
			btn.classList.remove("DocSearch-CodeSnippet-CopyButton--copied");
		});
		function handleClick(event) {
			var _btn$getAttribute;
			const btn = event.target.closest(".DocSearch-CodeSnippet-CopyButton");
			if (!btn) return;
			const encoded = (_btn$getAttribute = btn.getAttribute("data-code")) !== null && _btn$getAttribute !== void 0 ? _btn$getAttribute : "";
			navigator.clipboard.writeText(decodeURIComponent(encoded)).catch(() => {});
			const label = btn.querySelector(".DocSearch-CodeSnippet-CopyButton-Label");
			if (!label) return;
			btn.classList.add("DocSearch-CodeSnippet-CopyButton--copied");
			const original = copyButtonText;
			label.textContent = copyButtonCopiedText;
			setTimeout(() => {
				btn.classList.remove("DocSearch-CodeSnippet-CopyButton--copied");
				label.textContent = original;
			}, 1500);
		}
		container.addEventListener("click", handleClick);
		return () => {
			container.removeEventListener("click", handleClick);
		};
	}, [
		html,
		copyButtonText,
		copyButtonCopiedText
	]);
	return /* @__PURE__ */ React.createElement("div", {
		ref: containerRef,
		className: `DocSearch-Markdown-Content ${isStreaming ? "DocSearch-Markdown-Content--streaming" : ""}`,
		dangerouslySetInnerHTML: { __html: html }
	});
});
MemoizedMarkdown.displayName = "MemoizedMarkdown";

//#endregion
//#region src/utils/groupConsecutiveToolResults.ts
/**
* Groups consecutive search tool invocation result parts together. Both the
* `searchIndex` tool and the Algolia MCP search tools (`algolia_search_index`
* and `algolia_search_index_*`) are aggregated. Empty or falsy queries are
* ignored.
*/
function groupConsecutiveToolResults(parts) {
	const aggregatedParts = [];
	for (let i = 0; i < parts.length; i++) {
		const part = parts[i];
		if (isSearchOutputPart(part)) {
			const queries = [];
			let singleQueryPart;
			let j = i;
			while (j < parts.length) {
				const candidate = parts[j];
				if (isSearchOutputPart(candidate)) {
					const queriesForPart = getSearchToolQueries(candidate);
					queries.push(...queriesForPart);
					if (queriesForPart.length > 0) singleQueryPart = candidate;
					j++;
				} else break;
			}
			if (queries.length > 1) aggregatedParts.push({
				type: "aggregated-tool-call",
				queries
			});
			else if (queries.length === 1 && singleQueryPart) aggregatedParts.push(singleQueryPart);
			i = j - 1;
		} else aggregatedParts.push(part);
	}
	return aggregatedParts;
}

//#endregion
//#region src/Menu.tsx
const _excluded$1 = [
	"children",
	"className",
	"onClick"
];
const MenuContext = React.createContext({
	open: false,
	setOpen: (_open) => {}
});
function Menu({ children }) {
	const [open, setOpen] = React.useState(false);
	const menuRef = React.useRef(null);
	React.useEffect(() => {
		function close(e) {
			var _menuRef$current;
			if (!((_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.contains(e.target))) setOpen(false);
		}
		if (open) window.addEventListener("click", close);
		return function removeListener() {
			window.removeEventListener("click", close);
		};
	}, [open]);
	return /* @__PURE__ */ React.createElement(MenuContext.Provider, { value: {
		open,
		setOpen
	} }, /* @__PURE__ */ React.createElement("div", {
		ref: menuRef,
		className: "DocSearch-Menu"
	}, children));
}
function MenuTrigger({ children, className = "", disabled }) {
	const { open, setOpen } = React.useContext(MenuContext);
	function toggleOpen() {
		if (disabled) return;
		setOpen(!open);
	}
	return /* @__PURE__ */ React.createElement("button", {
		type: "button",
		className: `DocSearch-Menu-trigger ${className}${disabled ? " disabled" : ""}`,
		"aria-disabled": disabled,
		onClick: () => toggleOpen()
	}, children);
}
Menu.Trigger = MenuTrigger;
function MenuContent({ children }) {
	const { open } = React.useContext(MenuContext);
	return /* @__PURE__ */ React.createElement("div", { className: `DocSearch-Menu-content${open ? " open" : ""}` }, children);
}
Menu.Content = MenuContent;
function MenuItem(_ref) {
	let { children, className = "", onClick } = _ref, props = _objectWithoutProperties(_ref, _excluded$1);
	const { setOpen } = React.useContext(MenuContext);
	const handleClick = (e) => {
		if (onClick) {
			onClick(e);
			setOpen(false);
		}
	};
	return /* @__PURE__ */ React.createElement("button", _objectSpread2({
		type: "button",
		className: `DocSearch-Menu-item ${className}`,
		onClick: handleClick
	}, props), children);
}
Menu.Item = MenuItem;

//#endregion
//#region src/askai.ts
const agentStudioBaseUrl = (appId) => `https://${appId}.algolia.net/agent-studio/1`;
const getAgentStudioErrorMessage = (error) => {
	var _parsedError$code;
	const raw = error.message;
	let parsed;
	try {
		parsed = JSON.parse(raw);
	} catch (_unused) {
		return new Error(raw);
	}
	let iterations = 0;
	while (typeof parsed === "string" && iterations < 10) {
		iterations += 1;
		const serializedError = parsed.trim();
		try {
			parsed = JSON.parse(serializedError);
		} catch (_unused2) {
			return new Error(serializedError);
		}
	}
	if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return new Error(raw);
	const parsedRecord = parsed;
	const parsedError = parsed;
	let errorMessage = raw;
	if (parsedError.name === "ValidationError") {
		const validationError = parsedError;
		if (validationError.detail && validationError.detail.length > 0) {
			const { msg, loc } = validationError.detail[0];
			errorMessage = `${msg}: ${loc.at(-1)}`;
		}
	} else {
		var _ref, _readStringField;
		errorMessage = (_ref = (_readStringField = readStringField(parsedRecord, "message")) !== null && _readStringField !== void 0 ? _readStringField : readStringField(parsedRecord, "error")) !== null && _ref !== void 0 ? _ref : raw;
	}
	const code = (_parsedError$code = parsedError.code) !== null && _parsedError$code !== void 0 ? _parsedError$code : parsedError.errorCode;
	if (typeof code === "string" && code.trim() && !errorMessage.toUpperCase().includes(code.trim().toUpperCase())) errorMessage = `${errorMessage} (${code.trim()})`;
	return new Error(errorMessage);
};
const postAgentStudioFeedback = ({ agentId, vote, messageId, appId, apiKey, abortSignal, notes, tags }) => {
	const headers = new Headers();
	headers.set("x-algolia-application-id", appId);
	headers.set("x-algolia-api-key", apiKey);
	headers.set("content-type", "application/json");
	const baseUrl = `${agentStudioBaseUrl(appId)}/feedback`;
	return fetch(baseUrl, {
		method: "POST",
		body: JSON.stringify(_objectSpread2(_objectSpread2({
			messageId,
			agentId,
			vote
		}, notes ? { notes } : {}), tags && tags.length > 0 ? { tags } : {})),
		headers,
		signal: abortSignal
	});
};

//#endregion
//#region src/useAskAi.ts
const _excluded = [
	"id",
	"messages",
	"body"
];
const getAgentStudioTransport = ({ appId, apiKey, agentId, searchParameters, userToken, indices }) => {
	const algoliaParams = {};
	if (searchParameters) algoliaParams.searchParameters = searchParameters;
	if (indices && indices.length > 0) algoliaParams.indices = indices;
	return new DefaultChatTransport({
		api: `${agentStudioBaseUrl(appId)}/agents/${agentId}/completions?stream=true&compatibilityMode=ai-sdk-5`,
		headers: _objectSpread2({
			"x-algolia-application-id": appId,
			"x-algolia-api-key": apiKey
		}, userToken ? { "x-algolia-secure-user-token": userToken } : {}),
		body: { algolia: algoliaParams },
		prepareSendMessagesRequest(_ref) {
			let { id, messages, body } = _ref, rest = _objectWithoutProperties(_ref, _excluded);
			const sanitizedMessages = sanitizeMessagesForRequest(messages);
			return _objectSpread2(_objectSpread2({}, rest), {}, { body: _objectSpread2({
				id,
				messages: sanitizedMessages
			}, body) });
		}
	});
};
const useAskAi = ({ agentId, apiKey, appId, tools = EMPTY_TOOLS, searchParameters, memory, indices }) => {
	const abortControllerRef = useRef(new AbortController());
	const askAiTransport = useMemo(() => getAgentStudioTransport({
		apiKey,
		appId,
		agentId,
		searchParameters,
		userToken: memory === null || memory === void 0 ? void 0 : memory.userToken,
		indices
	}), [
		apiKey,
		appId,
		agentId,
		searchParameters,
		memory === null || memory === void 0 ? void 0 : memory.userToken,
		indices
	]);
	const askAiTransportRef = useRef(askAiTransport);
	askAiTransportRef.current = askAiTransport;
	const toolsRef = useRef(tools);
	toolsRef.current = tools;
	const addToolOutputRef = useRef(null);
	const handleToolCall = useCallback(({ toolCall }) => {
		const tool = toolsRef.current[toolCall.toolName];
		if (!(tool === null || tool === void 0 ? void 0 : tool.onToolCall)) return;
		tool.onToolCall(_objectSpread2(_objectSpread2({}, toolCall), {}, { addToolOutput: async ({ output }) => {
			if (!addToolOutputRef.current) return;
			await addToolOutputRef.current({
				output,
				tool: toolCall.toolName,
				toolCallId: toolCall.toolCallId
			});
		} }));
	}, []);
	const createChatInstance = useCallback((messages, id = generateId()) => new Chat({
		id,
		messages,
		sendAutomaticallyWhen: lastAssistantMessageIsCompleteWithToolCalls,
		transport: askAiTransportRef.current,
		onToolCall: handleToolCall
	}), [handleToolCall]);
	const [chatInstance, setChatInstance] = useState(() => createChatInstance());
	const chatInstanceRef = useRef(chatInstance);
	chatInstanceRef.current = chatInstance;
	const { messages, status, setMessages, error, stop, addToolOutput } = useChat({ chat: chatInstance });
	useEffect(() => {
		addToolOutputRef.current = addToolOutput;
	}, [addToolOutput]);
	const conversations = useRef(createStoredConversations({
		key: `__DOCSEARCH_ASKAI_CONVERSATIONS__${appId}`,
		limit: 10
	})).current;
	const sendFeedback = useCallback(async (messageId, { thumbs, tags, notes }) => {
		var _conversations$addFee;
		if (!agentId) return;
		if ((await postAgentStudioFeedback({
			agentId,
			vote: thumbs,
			messageId,
			appId,
			apiKey,
			abortSignal: abortControllerRef.current.signal,
			notes,
			tags
		})).status >= 300) throw new Error("Failed, try again later.");
		(_conversations$addFee = conversations.addFeedback) === null || _conversations$addFee === void 0 || _conversations$addFee.call(conversations, messageId, thumbs === 1 ? "like" : "dislike", {
			tags,
			notes
		});
	}, [
		agentId,
		appId,
		apiKey,
		conversations
	]);
	const onStopStreaming = useCallback(async () => {
		abortControllerRef.current.abort();
		await stop();
	}, [stop]);
	const exchanges = useMemo(() => {
		const grouped = [];
		for (let i = 0; i < messages.length; i++) if (messages[i].role === "user") {
			var _messages;
			const userMessage = messages[i];
			const assistantMessage = ((_messages = messages[i + 1]) === null || _messages === void 0 ? void 0 : _messages.role) === "assistant" ? messages[i + 1] : null;
			grouped.push({
				id: userMessage.id,
				userMessage,
				assistantMessage
			});
			if (assistantMessage) i++;
		}
		return grouped;
	}, [messages]);
	const isStreaming = status === "streaming" || status === "submitted";
	const askAiError = useMemo(() => {
		if (!error) return void 0;
		return getAgentStudioErrorMessage(error);
	}, [error]);
	const updateChatInstance = useCallback((restored, existingConversationId) => {
		const newChatInstance = createChatInstance(restored, existingConversationId);
		chatInstanceRef.current = newChatInstance;
		setChatInstance(newChatInstance);
	}, [createChatInstance]);
	const startNewConversation = useCallback(() => {
		updateChatInstance();
	}, [updateChatInstance]);
	const restoreConversation = useCallback((restored, existingConversationId) => {
		updateChatInstance(restored, existingConversationId);
	}, [updateChatInstance]);
	const sendMessageSafe = useCallback((...args) => chatInstanceRef.current.sendMessage(...args), []);
	return {
		chatId: chatInstance.id,
		messages,
		sendMessage: sendMessageSafe,
		status,
		setMessages,
		askAiError,
		stopAskAiStreaming: onStopStreaming,
		isStreaming,
		exchanges,
		conversations,
		sendFeedback,
		startNewConversation,
		restoreConversation
	};
};

//#endregion
//#region src/useSuggestedQuestions.ts
const useSuggestedQuestions = ({ agentId, searchClient, suggestedQuestionsEnabled = false }) => {
	const [suggestedQuestions, setSuggestedQuestions] = useState([]);
	useEffect(() => {
		const getSuggestedQuestions = async () => {
			const { results } = await searchClient.search({ requests: [{
				indexName: SUGGESTED_QUETIONS_INDEX_NAME,
				filters: `state:published AND assistantId:${agentId}`,
				hitsPerPage: 3
			}] });
			const result = results[0];
			setSuggestedQuestions(result.hits);
		};
		if (suggestedQuestionsEnabled && agentId && agentId !== "") getSuggestedQuestions();
	}, [
		suggestedQuestionsEnabled,
		agentId,
		searchClient
	]);
	return suggestedQuestions;
};

//#endregion
export { ConversationHistoryIcon as C, AlertIcon as E, NewConversationIcon as S, StopIcon as T, showAskAiBlockingBannerNewConversationLink as _, MemoizedMarkdown as a, ConversationPromptSuggestions as b, buildDummyAskAiHit as c, getAskAiBlockingBannerMessage as d, getMessageContent as f, isThreadDepthError as g, isAskAiPromptBlockingError as h, groupConsecutiveToolResults as i, extractLinksFromMessage as l, isAgentStudioTokenOutputLimitError as m, useAskAi as n, ToolCall as o, isAIToolPart as p, Menu as r, EMPTY_TOOLS as s, useSuggestedQuestions as t, getAgentPromptSuggestions as u, SourcesPanel as v, MoreVerticalIcon as w, BackIcon as x, FeedbackActions as y };
//# sourceMappingURL=useSuggestedQuestions-DfRr0-qE.js.map